import { createAction } from 'redux-actions';

export const toastShow = createAction('TOAST_SHOW');
export const toastHide = createAction('TOAST_HIDE');
